import { t } from '@lingui/macro';
import type { ApiClient } from '@prismo-io/schemas';
import { z } from 'zod';
import { SkillTypeEnum } from './skill-type-enum';

const ParamsSchema = z.object({
  type: SkillTypeEnum,
  id: z.string(),
});

export type ParamsSchemaT = z.infer<typeof ParamsSchema>;

const ResultSchema = z.boolean();

export type ResultSchemaT = z.infer<typeof ResultSchema>;

export const deleteSkill = async (
  client: ApiClient,
  params: ParamsSchemaT
): Promise<ResultSchemaT> => {
  const { type, id } = ParamsSchema.parse(params);

  const {
    data: { session },
  } = await client.auth.getSession();

  if (!session) {
    throw new Error(t`Vous devez être connecté.`);
  }

  const userId = session.user.id;

  switch (type) {
    case 'SKILLS':
      await client
        .from('quark_users_skills')
        .delete()
        .eq('id', id)
        .eq('user_id', userId)
        .throwOnError();

      break;

    case 'KNOWLEDGE':
      await client
        .from('quark_users_knowledges')
        .delete()
        .eq('id', id)
        .eq('user_id', userId)
        .throwOnError();

      break;

    default:
      throw new Error(t`Le type ne correspond à aucun skill`);
      break;
  }

  return ResultSchema.parse(true);
};
